import { render, staticRenderFns } from "./DispatchConsole.vue?vue&type=template&id=5c7d32b2&scoped=true&"
import script from "./DispatchConsole.vue?vue&type=script&lang=js&"
export * from "./DispatchConsole.vue?vue&type=script&lang=js&"
import style0 from "./DispatchConsole.vue?vue&type=style&index=0&id=5c7d32b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d32b2",
  null
  
)

export default component.exports